export default __webpack_public_path__ + "static/media/09AW1DEC65.e8f70e64.jpg";